import * as React from "react";
import { Grid, Navbar, NavDropdown, Nav, MenuItem,NavItem } from "react-bootstrap";
import { IAppState } from "./App";
import { ActDeckComponent } from "./ActDeck";
import { AgendaDeckComponent } from "./AgendaDeck";
import { InvestigatorAreaComponent } from "./InvestigatorArea";
import { CurrentPlayerSelectorComponent } from "./CurrentPlayerSelector";
import { IScenarioState, IResolution } from "./Scenario";
import { TokenComponent } from "./Token";
import { ChaosBagComponent } from "./ChaosBag";
import { CurrentLocationSelectorComponent } from "./CurrentLocationSelector";
import { IToken, GameToken } from "./Card";
import { OtherComponentSelectorComponent } from "./OtherComponentSelector";
import { IMenu, MainMenuComponent } from "./MainMenu";
import { CampaignLogComponent } from "./CampaignLogComponent";
import { PhaseCounterComponent } from "./PhaseCounterComponent";
import { VictoryDisplayComponent } from "./VictoryDisplayComponent";
import { Game } from "./Game";
import { GameStage } from "./GameStage";


enum ScenarioComponent {
    Default,
    EndScenario,
    CampaignLog,
    VictoryDisplay
}
interface IScenarioPlayState {
    activeComponent: ScenarioComponent;
}
export interface IScenarioPlayProps {
    state: IAppState;
    onComplete: () => void;
    onExitToMainMenu: () => void;
    onChanged: (state: IScenarioState) => void;
}
export class ScenarioPlayComponent extends React.Component<IScenarioPlayProps, IScenarioPlayState> {
    textDiv: any;
    typewriterSound: Howl;
    constructor(props: IScenarioPlayProps) {
        super(props);
        this.state = { activeComponent: ScenarioComponent.Default };
    }
    checkIfAllPlayersAreResigned() {
        const ss = this.props.state.scenarioState;
        //some players are left
        if (ss.investigators.filter(i => !i.resigned).length) {
            return;
        }
        const scenario = Game.getScenario(ss);
        const resolution = scenario.resolutions[0];
        this.onEndScenario(resolution);


    }
    onChildStateChanged() {
        this.props.onChanged({ ...this.props.state.scenarioState });
        this.setActiveComponent(ScenarioComponent.Default);

    }
    onEndScenario(resolution: IResolution): void {
        this.setActiveComponent(ScenarioComponent.Default);
        if (resolution) {
            this.props.state.scenarioState.resolution = resolution;
            this.onChildStateChanged();
            this.props.onComplete();
        }
    }

    setActiveComponent(component: ScenarioComponent) {
        this.setState({ activeComponent: component });
    }

    showScenarioIntro() {
        this.props.state.stage = GameStage.ScenarioIntro;
        this.onChildStateChanged();
    }
    getPlayArea(): JSX.Element {
        switch (this.state.activeComponent) {
            case ScenarioComponent.CampaignLog:
                return (<CampaignLogComponent state={this.props.state} onClose={() => this.setActiveComponent(ScenarioComponent.Default)} />);
            case ScenarioComponent.VictoryDisplay:
                return (<VictoryDisplayComponent state={this.props.state} onClose={() => this.setActiveComponent(ScenarioComponent.Default)} />);
        }
        const ss = this.props.state.scenarioState;
        const inv = ss.investigators[ss.currentSelectedInvestigator];
        const resourceToken: IToken = { token: GameToken.Resource, number: Infinity };
        const sanityToken: IToken = { token: GameToken.Sanity, number: Infinity };
        const healthToken: IToken = { token: GameToken.Health, number: Infinity };
        const clueToken: IToken = { token: GameToken.Clue, number: Infinity };
        const doomToken: IToken = { token: GameToken.Doom, number: Infinity };
        const actionToken: IToken = { token: GameToken.Action, number: Infinity };
        return (<div id="scenarioPlay">
            <div id="player-area">
                <CurrentPlayerSelectorComponent state={ss} onChanged={() => this.onChildStateChanged()} />
                <InvestigatorAreaComponent playerNumber={ss.currentSelectedInvestigator} state={inv} onChanged={() => this.onChildStateChanged()} />
            </div>
            <AgendaDeckComponent state={ss.agendaState} onChanged={() => this.onChildStateChanged()} />
            <ActDeckComponent state={ss.actState} onChanged={() => this.onChildStateChanged()} />
            <OtherComponentSelectorComponent state={ss} onChanged={() => this.onChildStateChanged()} />
            <div id="tokens">
                <TokenComponent token={resourceToken} valueChanged={() => { }} />
                <TokenComponent token={sanityToken} valueChanged={() => { }} />
                <TokenComponent token={healthToken} valueChanged={() => { }} />
                <TokenComponent token={clueToken} valueChanged={() => { }} />
                <TokenComponent token={doomToken} valueChanged={() => { }} />
                <TokenComponent token={actionToken} valueChanged={() => {}}/>
            </div>
            <ChaosBagComponent chaosBag={this.props.state.scenarioState.chaosBag} />
            <CurrentLocationSelectorComponent state={ss} onChanged={() => this.onChildStateChanged()} />
            {this.state.activeComponent === ScenarioComponent.EndScenario
                ? <SelectEndScenarioComponent state={this.props.state}
                    onClose={(resolution: IResolution) => this.onEndScenario(resolution)} />
                : null}
            <PhaseCounterComponent state={this.props.state.scenarioState} onChanged={() => this.onChildStateChanged()} />
        </div>);
    }

    render() {
        setTimeout(() => { this.checkIfAllPlayersAreResigned(); }, 500);
        const ss = this.props.state.scenarioState;
        const campaign = Game.getCampaign(ss);
        const scenario = Game.getScenario(ss);
        const element = this.getPlayArea();

        return (
            <Grid fluid={true}>
                <Navbar className="navbar-arkham" fluid={true}>
                    <Navbar.Header>
                        <span className="logo"></span>
                        <Navbar.Brand>
                            <h1>{campaign.name}: {scenario.name}</h1>
                        </Navbar.Brand>
                        <Navbar.Toggle />
                    </Navbar.Header>
                    <Navbar.Collapse>
                        <Nav pullRight={true}>

                            <NavDropdown eventKey={3} title="Menu" id="basic-nav-dropdown2">
                                <MenuItem eventKey={3.1} onClick={() => this.showScenarioIntro()}>Scenario Intro</MenuItem>
                                <MenuItem eventKey={3.2} onClick={() => this.setActiveComponent(ScenarioComponent.VictoryDisplay)}>Victory Display</MenuItem>
                                <MenuItem eventKey={3.3} onClick={() => this.setActiveComponent(ScenarioComponent.CampaignLog)}>Campaign Log</MenuItem>
                                <MenuItem eventKey={3.4} onClick={() => this.setActiveComponent(ScenarioComponent.EndScenario)}>End Scenario</MenuItem>
                                <MenuItem divider/>
                                <MenuItem eventKey={3.5} target="_learnToPlay" href="https://images-cdn.fantasyflightgames.com/filer_public/88/53/88538d11-5274-4b4a-ac8c-e8d758f71132/ahc01_learn_to_play_web.pdf">Rules: Learn to Play</MenuItem>
                                <MenuItem eventKey={3.6} target="_ruleReference" href="https://images-cdn.fantasyflightgames.com/filer_public/c4/b0/c4b0d66c-d79e-411b-bdb5-b5d8c457d4bc/ahc01_rules_reference_web.pdf">Rules: Reference</MenuItem>
                                <MenuItem divider />
                                <MenuItem eventKey={3.7} onClick={() => this.props.onExitToMainMenu()}>Quit to Main Menu</MenuItem>
                            </NavDropdown>
                            <NavItem style={{ width: 160 }} disabled={true}></NavItem>
                           
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>


                <div className="col col-md-12">
                    {element}
                </div>
            </Grid>
        );
    }

}
export interface ISelectEndScenarioProps {
    state: IAppState;
    onClose: (resolution?: IResolution) => void;
}
export class SelectEndScenarioComponent extends React.Component<ISelectEndScenarioProps, any> {

    setResolution(resolution: IResolution) {
        this.props.onClose(resolution);
    }
    render() {
        const menu: IMenu = {
            title: "End scenario",
            items: [
                { title: "Cancel", action: () => { this.props.onClose(); } }]
        };
        const scenario = Game.getScenario(this.props.state.scenarioState);
        const items = scenario.resolutions.map((r) => {
            return { title: r.text.title, action: () => this.props.onClose(r) }
        });
        for (let i = 0; i < items.length; i++) {
            menu.items.splice(i, 0, items[i]);
        }
        return (<MainMenuComponent menu={menu} />);
    }
}
